import {
  SET_IS_VD_ABOVE_ATC_RENDERED,
  SET_IS_PA_ABOVE_ATC_RENDERED,
} from '../constants';

export function setIsVDAboveATCRendered(datapack) {
  return {
    type: SET_IS_VD_ABOVE_ATC_RENDERED,
    ...datapack,
  };
}

export function setIsProductAddonsAboveATCRendered(datapack) {
  return {
    type: SET_IS_PA_ABOVE_ATC_RENDERED,
    ...datapack,
  };
}
